export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostHeader.vue?vue&type=template&id=19cc29e6&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostHeader.vue?vue&type=template&id=19cc29e6&scoped=true&
// module id = 246
// module chunks = 0